import socket from '@app/utils/socket';
import { extractApiData, ApiResponse } from '@app/types/api';
import type { SocketRequestProps } from '@app/types/socket';

const api = {
  get: async <T>(url: string, data: SocketRequestProps = {}): Promise<T> => {
    const response: ApiResponse<T> = await socket.get(url, data);
    return extractApiData(response);
  },
  /**
   * GET sans extractApiData — pour les réponses dont la structure
   * ne suit pas le format { success, data } (ex: pagination Laravel).
   */
  getRaw: async <T>(url: string, data: SocketRequestProps = {}): Promise<T> => {
    const response: T = await socket.get(url, data);
    return response;
  },
  post: async <T>(url: string, data: SocketRequestProps = {}): Promise<T> => {
    const response: ApiResponse<T> = await socket.post(url, data);
    return extractApiData(response);
  },
  put: async <T>(url: string, data: SocketRequestProps = {}): Promise<T> => {
    const response: ApiResponse<T> = await socket.put(url, data);
    return extractApiData(response);
  },
  delete: async <T>(url: string, data: SocketRequestProps = {}): Promise<T> => {
    const response: ApiResponse<T> = await socket.delete(url, data);
    return extractApiData(response);
  }
};

export default api;
